import type { CSSProperties } from "react";
import appColors from "../../../app/appColors";

export function getPdfCanvasPanelBaslikStyle(isWideLayout: boolean): CSSProperties {
    return {
        fontWeight: 600,
        fontSize: isWideLayout ? "0.85rem" : "0.92rem",
        marginBottom: "5px",
    };
}

export function getPdfCanvasPanelGrupStyle(): CSSProperties {
    return {
        flexShrink: 0,
        minHeight: 0,
        border: `1px solid ${appColors.GRAY_LIGHT3}`,
        borderRadius: 8,
        background: appColors.GRAY_LIGHT5,
    };
}
